import {Component, Input} from '@angular/core';
import {ModalService} from "../../../core/modal/modal.service";
import {Router} from "@angular/router";

@Component({
  selector: 'tax-cancel-disconnection-ofd-modal',
  templateUrl: './cancel-disconnection-ofd-modal.component.html',
  styleUrls: ['./cancel-disconnection-ofd-modal.component.scss']
})
export class CancelDisconnectionOfdModalComponent {
  @Input() kkmId = 0;

  constructor(
    private modalService: ModalService,
    private router: Router,
  ) {}

  confirm() {
    this.modalService.close();
    this.router.navigateByUrl(`/main/kkms/cancel-disconnection-ofd-agreement/${this.kkmId}`);
  }

}
